import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import {
    renderField,
    renderToggle,
    required,
    renderTextArea,
    number,
    minValue, renderSelectField,
} from "../../../../utils/formValidations.js";
import SelectInput from "../../../../components/SelectInput";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";
import {withTranslation} from "react-i18next";
import { Button, FormFooter, Groups, FormField } from "../../../../components/Form"

const minValue50 = minValue(50);

const windows_startup_script_types = [
    {value: "sysprep-specialize-script-ps1", label: "sysprep powershell script"},
    {value: "sysprep-specialize-script-cmd", label: "sysprep command shell script"},
    {value: "sysprep-specialize-script-bat", label: "sysprep batch file script"},
    {value: "windows-startup-script-ps1", label: "powershell script"},
    {value: "windows-startup-script-cmd", label: "command shell script"},
    {value: "windows-startup-script-bat", label: "batch file script"},
]

const linux_startup_script_types = [
    {value: "startup-script", label: "bash script"},
]

class GcpProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
            };
            this.submitApi = this.submitApi.bind(this);
            this.cancelButton = this.cancelButton.bind(this);
        }

        componentDidMount() {
            if (this.props.current_provider) {
                this.props.initialize({
                    vm_provider_config_name: this.props.current_provider.vm_provider_config_name,
                    vm_provider_name: this.props.current_provider.vm_provider_name,

                    max_instances: this.props.current_provider.max_instances,
                    vm_installed_os_type: this.props.current_provider.vm_installed_os_type,
                    startup_script_type: this.props.current_provider.startup_script_type,

                startup_script: this.props.current_provider.startup_script,

                gcp_project: this.props.current_provider.gcp_project,
                gcp_region: this.props.current_provider.gcp_region,
                gcp_zone: this.props.current_provider.gcp_zone,
                gcp_machine_type: this.props.current_provider.gcp_machine_type,
                gcp_image: this.props.current_provider.gcp_image,
                gcp_boot_volume_gb: this.props.current_provider.gcp_boot_volume_gb,
                gcp_cmek: this.props.current_provider.gcp_cmek,
                gcp_disk_type: this.props.current_provider.gcp_disk_type,
                gcp_network: this.props.current_provider.gcp_network,
                gcp_subnetwork: this.props.current_provider.gcp_subnetwork,
                gcp_public_ip: this.props.current_provider.gcp_public_ip,
                gcp_network_tags: this.props.current_provider.gcp_network_tags ? JSON.stringify(this.props.current_provider.gcp_network_tags, null, 2) : '',
                gcp_custom_labels: this.props.current_provider.gcp_custom_labels ? JSON.stringify(this.props.current_provider.gcp_custom_labels, null, 2) : '',
                gcp_credentials: this.props.current_provider.gcp_credentials && this.props.current_provider.gcp_credentials === '**********' ? this.props.current_provider.gcp_credentials : JSON.stringify(this.props.current_provider.gcp_credentials, null, 2),
                gcp_metadata: this.props.current_provider.gcp_metadata ? JSON.stringify(this.props.current_provider.gcp_metadata, null, 2) : '',
                gcp_service_account: this.props.current_provider.gcp_service_account ? JSON.stringify(this.props.current_provider.gcp_service_account, null, 2) : '',
                gcp_guest_accelerators: this.props.current_provider.gcp_guest_accelerators ? JSON.stringify(this.props.current_provider.gcp_guest_accelerators, null, 2) : '',
                gcp_config_override: this.props.current_provider.gcp_config_override ? JSON.stringify(this.props.current_provider.gcp_config_override, null, 2) : '',
            });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
                vm_provider_name: nextProps.current_provider.vm_provider_name,

                max_instances: nextProps.current_provider.max_instances,
                vm_installed_os_type: nextProps.current_provider.vm_installed_os_type,
                startup_script_type: nextProps.current_provider.startup_script_type,
                startup_script: nextProps.current_provider.startup_script,

                gcp_project: nextProps.current_provider.gcp_project,
                gcp_region: nextProps.current_provider.gcp_region,
                gcp_zone: nextProps.current_provider.gcp_zone,
                gcp_machine_type: nextProps.current_provider.gcp_machine_type,
                gcp_image: nextProps.current_provider.gcp_image,
                gcp_boot_volume_gb: nextProps.current_provider.gcp_boot_volume_gb,
                gcp_cmek: nextProps.current_provider.gcp_cmek,
                gcp_disk_type: nextProps.current_provider.gcp_disk_type,
                gcp_network: nextProps.current_provider.gcp_network,
                gcp_subnetwork: nextProps.current_provider.gcp_subnetwork,
                gcp_public_ip: nextProps.current_provider.gcp_public_ip,
                gcp_network_tags: nextProps.current_provider.gcp_network_tags ? JSON.stringify(nextProps.current_provider.gcp_network_tags, null, 2) : '',
                gcp_custom_labels: nextProps.current_provider.gcp_custom_labels ? JSON.stringify(nextProps.current_provider.gcp_custom_labels, null, 2) : '',
                gcp_credentials: nextProps.current_provider.gcp_credentials && nextProps.current_provider.gcp_credentials === '**********' ? nextProps.current_provider.gcp_credentials : JSON.stringify(this.props.current_provider.gcp_credentials, null, 2),
                gcp_metadata: nextProps.current_provider.gcp_metadata ? JSON.stringify(nextProps.current_provider.gcp_metadata, null, 2) : '',
                gcp_service_account: nextProps.current_provider.gcp_service_account ? JSON.stringify(nextProps.current_provider.gcp_service_account, null, 2) : '',
                gcp_guest_accelerators: nextProps.current_provider.gcp_guest_accelerators ? JSON.stringify(nextProps.current_provider.gcp_guest_accelerators, null, 2) : '',
                gcp_config_override: nextProps.current_provider.gcp_config_override ? JSON.stringify(nextProps.current_provider.gcp_config_override, null, 2) : '',
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }

    submitApi(userData) {
        userData.vm_provider_name = "gcp"
        this.props.submit_api(userData)
    }

    render() {
        const { handleSubmit, t, vm_provider_values } = this.props;
        const { currentZone } = this.state;
        const gcp_public_ip_checked = currentZone && currentZone.gcp_public_ip;

        return (
            <Groups noPadding section="providers" onSubmit={handleSubmit(this.submitApi)}>
                <FormField label="Name">
                    <Field type="text"
                        name="vm_provider_config_name"
                        id="vm_provider_config_name"
                        component={renderField}
                        validate={required} required
                        placeholder={t("providers.Example Google Cloud Config")}
                    />
                </FormField>
                <FormField label="GCP Credentials (JSON)">
                    <Field type="text"
                        name="gcp_credentials"
                        id="gcp_credentials"
                        help="kb-24-gcp-1"
                        placeholder='{"foo" : "bar"}'
                        component={renderTextArea}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Max Instances">
                    <Field type="number"
                        name="max_instances"
                        id="max_instances"
                        help="kb-24-gcp-2"
                        placeholder="10"
                        component={renderField}
                        validate={number} required
                    />
                </FormField>
                <FormField label="Project ID">
                    <Field type="text"
                        name="gcp_project"
                        id="gcp_project"
                        help="kb-24-gcp-3"
                        placeholder="project-name"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Region">
                    <Field type="text"
                        name="gcp_region"
                        id="gcp_region"
                        help="kb-24-gcp-4"
                        placeholder="us-east4"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Zone">
                    <Field type="text"
                        name="gcp_zone"
                        id="gcp_zone"
                        help="kb-24-gcp-5"
                        placeholder="us-east4-b"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Machine Type">
                    <Field type="text"
                        name="gcp_machine_type"
                        id="gcp_machine_type"
                        help="kb-24-gcp-6"
                        placeholder="e2-standard-2"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Machine Image">
                    <Field type="text"
                        name="gcp_image"
                        id="gcp_image"
                        help="kb-24-gcp-7"
                        placeholder="projects/debian-cloud/global/images/debian-10-buster-v20211209"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Boot Volume GB">
                    <Field type="text"
                        name="gcp_boot_volume_gb"
                        id="gcp_boot_volume_gb"
                        help="kb-24-gcp-8"
                        placeholder="50"
                        component={renderField}
                        validate={[number, minValue50]} required
                    />
                </FormField>
                <FormField label="Disk Type">
                    <Field type="text"
                        name="gcp_disk_type"
                        id="gcp_disk_type"
                        help="kb-24-gcp-9"
                        placeholder="pd-ssd"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Customer Managed Encryption Key (CMEK)">
                    <Field type="text"
                        name="gcp_cmek"
                        id="gcp_cmek"
                        help="kb-24-gcp-10"
                        placeholder="projects/project-name/locations/global/keyRings/my-keyring/cryptoKeys/my-key"
                        component={renderField}
                    />
                </FormField>
                <FormField label="Network">
                    <Field type="text"
                        name="gcp_network"
                        id="gcp_network"
                        help="kb-24-gcp-11"
                        placeholder="projects/project-name/global/networks/default"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Sub Network">
                    <Field type="text"
                        name="gcp_subnetwork"
                        id="gcp_subnetwork"
                        help="kb-24-gcp-12"
                        placeholder="projects/project-name/regions/us-east4/subnetworks/default"
                        component={renderField}
                        validate={required} required
                    />
                </FormField>
                <FormField label="Public IP">
                    <Field type="checkbox"
                        name="gcp_public_ip"
                        id="gcp_public_ip"
                        help="kb-24-gcp-13"
                        checked={gcp_public_ip_checked}
                        component={renderToggle}
                    />
                </FormField>
                <FormField label="Network Tags (JSON)">
                    <Field type="text"
                        name="gcp_network_tags"
                        id="gcp_network_tags"
                        help="kb-24-gcp-14"
                        placeholder='["https-server"]'
                        component={renderTextArea}
                    />
                </FormField>
                <FormField label="Custom Labels (JSON)">
                    <Field type="text"
                        name="gcp_custom_labels"
                        id="gcp_custom_labels"
                        help="kb-24-gcp-15"
                        placeholder='{"foo" : "bar"}'
                        component={renderTextArea}
                    />
                </FormField>
                <FormField label="Metadata (JSON)">
                    <Field type="text"
                        name="gcp_metadata"
                        id="gcp_metadata"
                        help="kb-24-gcp-16"
                        placeholder='[{}]'
                        component={renderTextArea}
                    />
                </FormField>
                <FormField label="Service Account (JSON)">
                    <Field type="text"
                        name="gcp_service_account"
                        id="gcp_service_account"
                        help="kb-24-gcp-17"
                        placeholder='{}'
                        component={renderTextArea}
                    />
                </FormField>
                <FormField label="Guest Accelerators (JSON)">
                    <Field type="text"
                        name="gcp_guest_accelerators"
                        id="gcp_guest_accelerators"
                        help="kb-24-gcp-18"
                        placeholder='[]'
                        component={renderTextArea}
                    />
                </FormField>
                <FormField label="GCP Config Override (JSON)">
                    <Field type="text"
                        name="gcp_config_override"
                        id="gcp_config_override"
                        help="kb-24-gcp-19"
                        placeholder='{}'
                        component={renderTextArea}
                    />
                </FormField>
                <FormField label="Installed OS Type">
                  <Field type="text"
                    name="vm_installed_os_type"
                    id="vm_installed_os_type"
                    help="kb-24-gcp-20"
                    component={renderSelectField}
                    validate={required} required>
                      <option>{t("providers.Select")}</option>
                      <option value="linux">linux</option>
                      <option value="windows">windows</option>
                  </Field>
                </FormField>
                <FormField label="Startup Script Type">
                  <Field type="text"
                    name="startup_script_type"
                    id="startup_script_type"
                    help="kb-24-gcp-21"
                    selectedValue={vm_provider_values && vm_provider_values.startup_script_type}
                    options={vm_provider_values && vm_provider_values.vm_installed_os_type === "windows" ? windows_startup_script_types : linux_startup_script_types }
                    component={SelectInput}>
                  </Field>
                </FormField>
                <FormField label="Startup Script">
                    <Field type="text"
                        name="startup_script"
                        id="startup_script"
                        help="kb-24-gcp-22"
                        placeholder="#!/bin/bash&#10;..."
                        component={renderTextArea}
                    />
                </FormField>
                <FormFooter
                    cancelButton={<button className="cancel-button tw-bg-transparent" type="cancel" onClick={() => this.props.cancel_button()}> {this.props.wizard ? t("buttons.Previous") : t("buttons.Cancel")}</button>}
                    saveButton={<Button id="save-gcp-vm" icon="save" type="submit" section="buttons" name={!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? t("buttons.Next") : t("buttons.Finish")} />}
                />
            </Groups>
        );
    }
}

GcpProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
    vm_provider_values: Proptypes.object,
};

let GcpProviderFormWithRouter = withRouter(GcpProviderFormTemplate);

let GcpProviderForm = connect(state => {

    return {
        vm_provider_configs: state.vm_provider.vm_provider_configs,
        vm_provider_values: state.form && state.form.VmProviderForm && state.form.VmProviderForm.values ? state.form.VmProviderForm.values : null,
    }
},

    dispatch =>
    ({

    }))(GcpProviderFormWithRouter);
    const GcpProviderFormTranslated = withTranslation('common')(GcpProviderForm)
export default reduxForm({
    form: "VmProviderForm",
})(GcpProviderFormTranslated);
